// Global Theme Functions
	const cavera = {};
	cavera.currency_formatter = function( value = false, currency = 'USD', hide_whole_decimal = false ) {
		var formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: currency
		});
		var formatted_price = formatter.format(value / 100);
		if( hide_whole_decimal &&  formatted_price.endsWith('.00')){
			formatted_price = formatted_price.slice(0, -3);
		}
		return formatted_price;
	};
	cavera.has_json_structure = function(str) {
		if (typeof str !== 'string') return false;
		try {
			const result = JSON.parse(str);
			const type = Object.prototype.toString.call(result);
			return type === '[object Object]' ||
			type === '[object Array]';
		} catch (err) {
			return false;
		}
	};

// Global Alpine Functions
	document.addEventListener('alpine:init', () => {
		Alpine.data('product_details', ( data = [] ) => ({
			product: data.product,
			availability: data.availability,
			options: data.options,
			accordion: data.accordion,
			selected_options: {},
			selected_variant: false,
			selected_media: 0,
			alt_media: false,
			qty: 1,
			max_qty: 0,
			bundle_id: false,
			cart: {},
			init() {
				let searchParams = new URLSearchParams( window.location.search );
				let variant_id = searchParams.get( 'variant' );
				if(variant_id){
					this.find_matching_variant( variant_id );
				} else {
					this.find_first_available_variant();
				}
				//this.cart_check();
				this.$watch( 'selected_options',( value ) => this.find_matching_variant() );
			},
			find_first_available_variant(){
				for ( let variant of this.product.variants ) {
					if ( variant.available ){
						this.selected_variant = JSON.parse( JSON.stringify( variant ) );
						this.selected_options = JSON.parse( JSON.stringify( variant.options ) );
						break;
					};
				}
				if( !this.selected_variant ){
					console.log('No available variants so first variant selected');
					this.selected_variant = JSON.parse( JSON.stringify( this.product.variants[0] ));
					this.selected_options = JSON.parse( JSON.stringify( this.product.variants[0].options ));
				}
				if( this.selected_variant.featured_image ){
					this.set_product_image( this.selected_variant.featured_image.position - 1 );
				}
				this.variant_availability( this.selected_variant );
			},
			cart_check(){
				fetch("/cart.js", { method: "GET", headers: { "Content-Type": "application/json" } } ).then(response => { response.json().then(cart => {
					this.cart = cart;
					this.variant_availability( this.selected_variant );
				})})
			},
			variant_availability( variant ){
				var qty_in_cart = 0;
				if( this.cart.item_count > 0 ){
					for( var item of this.cart.items ){
						if( item.variant_id == this.selected_variant.id ){
							qty_in_cart = qty_in_cart + item.quantity;
						}
					}
				}
				if( this.availability[variant.id][1] == 'deny' ){
					this.max_qty = this.availability[variant.id][0] - qty_in_cart;
				} else {
					this.max_qty = 100000
				}
				if( this.qty > this.max_qty ){
					this.qty = this.max_qty;
				} else if( this.qty < 1){
					this.qty = 1;
				}
			},
			find_matching_variant( id = false ){
				var found = false;
				if( id ){
					for ( var variant of this.product.variants ) {
						if ( variant.id == id ){
							this.selected_options = JSON.parse( JSON.stringify( variant.options ) );
							found = JSON.parse( JSON.stringify( variant ) );
							break;
						};
					}
				} else {
					for ( var variant of this.product.variants ) {
						if( JSON.stringify( variant.options ) === JSON.stringify( this.selected_options ) ){
						 	found = variant;
							break;
						}
					};
				}
				if ( found ){
					this.selected_variant = found;
					searchParams = new URLSearchParams( window.location.search );
					searchParams.set('variant', found.id);
					searchParams.sort();
					window.history.replaceState( {}, found.name, window.location.origin + window.location.pathname + "?" + searchParams.toString() );
					this.variant_availability( found );
					if( found.featured_image ){
						this.set_product_image( found.featured_image.position - 1 );
					}
				} else { // if unable to set variant
					this.find_first_available_variant();
				}
			},
			set_product_image( i ){
				if( Number.isInteger( i ) && this.product.media[i] ){
					this.selected_media = i;
					this.alt_media = false;
				}
			}
		}));
	});
